export class PzModel {
  public estimatedPricePlayer1: number;
  public estimatedPricePlayer2: number;

  public estimatedPricePlayer1_password: string;
  public estimatedPricePlayer2_password: string;

  public priceAmazon: number;

  public pointsPlayer1: number;
  public pointsPlayer2: number;

  public senfkartePlayer1: boolean;
  public senfkartePlayer2: boolean;

  public senfkartePlayer1Possible: boolean;
  public senfkartePlayer2Possible: boolean;

  public constructor(
    estimatedPricePlayer1: number,
    estimatedPricePlayer2: number,
    priceAmazon: number
  ) {
    this.pointsPlayer1 = 0;
    this.pointsPlayer2 = 0;
    this.estimatedPricePlayer1 = estimatedPricePlayer1;
    this.estimatedPricePlayer2 = estimatedPricePlayer2;
    this.priceAmazon = priceAmazon;
    this.senfkartePlayer1 = false;
    this.senfkartePlayer2 = false;
    this.senfkartePlayer1Possible = true;
    this.senfkartePlayer2Possible = true;
    this.estimatedPricePlayer1_password = '';
    this.estimatedPricePlayer2_password = '';
  }
}
